import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/assets/icons/left-arrow-circle.svg");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/ApolloNextAppProvider.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/hooks.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/common/Analytics/CustomButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/BlogDetailsNewWrapper/ContentBody/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/BlogDetailsNewWrapper/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/molecules/ListingBanner/BlogsListingBanner.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SectionCard/SectionCard.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/SocialMediaSection/SocialMediaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/BlogsListSection/BlogsListSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/organisms/SimilarBlogsSection/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/molecules/TagsAndSocialMediaSection/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/organisms/SimilarProgramsSection/SimilarProgramsSection.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/Breadcrumbs/BreadCrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/frontend/src/components/sections/FaqSection/Faq.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/components/templates/Faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/frontend/src/revamp/organisms/BlogLeadForm/index.tsx");
